(function () {
    'use strict';

    a3_cabin_reports.directive('annualLeavesSummary', annualLeavesSummary);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name annualLeavesSummary
    * @restrict E
    * @description
    *    Implementation of annual Leaves Summary
    * @example
    *   Usage:
    *   <annual-leaves-summary></annual-leaves-summary>
    * @ngInject
    */
    function annualLeavesSummary(AnnualLeavesFactory) {
        function link($scope, element, attrs) {
            $scope.showAnnualLeavesSummary = false;

            var annualLeavesInfo = AnnualLeavesFactory.getAnnualLeavesToStorage();
            if (annualLeavesInfo && annualLeavesInfo.length > 0){
                $scope.showAnnualLeavesSummary = true;
                $scope.annualLeaves = groupAnnualLeavesByType(annualLeavesInfo);
            } 

            function groupAnnualLeavesByType(annualLeavesInfo) {
                var groupedLeaves = [];
                annualLeavesInfo = annualLeavesInfo.sort(function (a, b) {
                   return b.Date < a.Date ? 1: -1 
                });
           
                for (var i = 0; i < annualLeavesInfo.length; i++) {
                    var previousGroup = groupedLeaves[groupedLeaves.length - 1];
                    if (i != 0 && previousGroup.type == annualLeavesInfo[i].Type && (new Date(annualLeavesInfo[i].Date) - new Date(previousGroup.dates[previousGroup.dates.length - 1]) === 86400000)) {
                        previousGroup.dates.push(annualLeavesInfo[i].Date);
                    }
                    else {
                        var item = { type: annualLeavesInfo[i].Type, dates: [] };
                        item.dates.push(annualLeavesInfo[i].Date);
                        groupedLeaves.push(item);
                    }
                }
                return groupedLeaves;
            }

        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/LeaveRequest/annual-leaves-summary.tpl.html',
            scope: true,
            link: link
        }
    }

})();